import * as React from 'react';

const SvgDirectory = props => {
  const { size, fill } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill={fill}
      {...props}
    >
      <path d="M20.15 4a.5.5 0 01-.4-.49V2a2 2 0 00-2-2H5.25a3 3 0 00-3 3v18a3 3 0 003 3h14.5a2 2 0 002-2V6a2 2 0 00-1.6-2zm-9.74 11.8a5 5 0 01-1.13-3.51 2.89 2.89 0 013-3.06 2.89 2.89 0 013 3.06 5 5 0 01-1.15 3.53c-.07.12-.08.6 0 .69 2.06.74 3.2 1.28 3.65 2.16a5.09 5.09 0 01.49 1.47.5.5 0 01-.49.59h-11a.5.5 0 01-.49-.59 5.09 5.09 0 01.49-1.47c.45-.88 1.59-1.42 3.67-2.16a1 1 0 00-.04-.67zM5.25 2H17.5a.25.25 0 01.25.25v1.5a.25.25 0 01-.25.25H5.25a1 1 0 010-2z" />
    </svg>
  );
};

export default SvgDirectory;
